import { memo, useMemo } from 'react';

import type { TableWidgetData } from '@/features/_shared/widget-registry';
import { useMarketPreview } from '@/features/markets/api';
import MarketsComponents from '@/features/markets/components';
import type { MarketsPageType } from '@/features/markets/types';
import { PageInformationContext } from '@/shared/lib/PageInformationContext';
import { Spinner } from '@/shared/ui/feedback/Spinner';
import { Box } from '@/shared/ui/layout/Box';

import { buildTemplate } from './tablePreviewTemplate';

export const MarketPreviewShell = ({
  previewData,
  isLoading
}: {
  previewData: MarketsPageType | null | undefined;
  isLoading: boolean;
}) => (
  <PageInformationContext value={{ mainPageTitle: 'AI Chat' }}>
    {isLoading ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <Spinner
          centered={false}
          size={24}
        />
      </Box>
    ) : (
      previewData && (
        <MarketsComponents
          forChat
          showAddToDashboard
          components={previewData.components}
          showShareBlock={false}
        />
      )
    )}
  </PageInformationContext>
);

export const MarketPreviewWidget = memo(({ data }: { data: TableWidgetData }) => {
  const template = useMemo(() => buildTemplate(data), [data]);
  const { data: previewData, isLoading } = useMarketPreview(template);
  return (
    <MarketPreviewShell
      previewData={previewData}
      isLoading={isLoading}
    />
  );
});

MarketPreviewWidget.displayName = 'MarketPreviewWidget';
